// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes, Translate, Measure, classNames } from '@plesk/ui-library';

class Promo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: this.props.items,
            width: null,
            currentPage: 0,
        };

        this.handleNextPage = this.handleNextPage.bind(this);
        this.handlePrevPage = this.handlePrevPage.bind(this);
        this.handleCloseItem = this.handleCloseItem.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    handleNextPage() {
        let { currentPage } = this.state;

        currentPage++;
        if (currentPage > this.getCountPages() - 1) {
            currentPage = 0;
        }

        this.setState({ currentPage });
    }

    handlePrevPage() {
        let { currentPage } = this.state;

        currentPage--;
        if (currentPage < 0) {
            currentPage = this.getCountPages() - 1;
        }

        this.setState({ currentPage });
    }

    handleCloseItem(item) {
        let { currentPage } = this.state;
        const items = [...this.state.items];
        items.splice(items.indexOf(item), 1);

        if (currentPage * this.getRows() >= items.length) {
            currentPage--;
        }

        this.setState({ items, currentPage });
        if (this.props.onCloseItem) {
            this.props.onCloseItem(item);
        }
        if (!items.length && this.props.onCloseLastItem) {
            this.props.onCloseLastItem();
        }
    }

    handleResize(contentRect) {
        this.setState({
            width: contentRect.bounds.width,
        });
    }

    getCurrentItems() {
        const current = this.state.currentPage * this.getRows();
        return this.state.items.slice(current, current + this.getRows());
    }

    getCountPages() {
        return Math.ceil(this.state.items.length / this.getRows());
    }

    getRows() {
        return Math.max(Math.floor(this.state.width / 300), 1);
    }

    renderItem(item, key) {
        const { buttonUrl, buttonTarget, buttonText, iconUrl, title, text, hideText } = item;

        return (
            <div className="tools-item tools-item-active" key={key}>
                <a className="tool-block" href={buttonUrl} target={buttonTarget}>
                    <span className="tool-icon"><img src={iconUrl} /></span>
                    <span className="tool-name">{title}</span>
                    <span className="tool-info">{text}</span>
                </a>
                <div className="tool-actions">
                    <a href={buttonUrl} className="btn" target={buttonTarget}>{buttonText}</a>
                    <a className="link-02" onClick={() => this.handleCloseItem(item)}><span>{hideText}</span></a>
                </div>
            </div>
        );
    }

    render() {
        const { className, baseClassName, title } = this.props;
        const items = this.getCurrentItems();

        if (!items.length) {
            return null;
        }

        const countPages = this.getCountPages();

        return (
            <div className={classNames(baseClassName, className)}>
                {title && (
                    <div className="p-box-header">
                        <div className="p-box-header-text">{title}</div>
                    </div>
                )}
                <div className="p-box-content">
                    <Measure onResize={this.handleResize} bounds>
                        {({ measureRef }) => (
                            <ul ref={measureRef} className="tools-list">
                                {items.map((item, key) => this.renderItem(item, key))}
                            </ul>
                        )}
                    </Measure>
                </div>
                {countPages > 1 && (
                    <div className="p-box-footer">
                        <div className="p-box-footer-nav">
                            <a className="prev-link" onClick={this.handlePrevPage}><span><Translate content="prev" /></span></a>
                            {' '}
                            <a className="next-link" onClick={this.handleNextPage}><span><Translate content="next" /></span></a>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
Promo.propTypes = {
    items: PropTypes.array.isRequired,
    baseClassName: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    onCloseItem: PropTypes.func,
    onCloseLastItem: PropTypes.func,
};
Promo.defaultProps = {
    baseClassName: 'p-box',
    className: null,
    title: null,
    onCloseItem: null,
    onCloseLastItem: null,
};

export default Promo;



// WEBPACK FOOTER //
// ./app/promo/Promo.js